import { jsx as _jsx } from "react/jsx-runtime";
import { Icon, Tooltip, Breadcrumb as ZenBreacrumb, } from '@zenlayer/zen-design';
import t from '@zenlayer/zen-intl18';
const BreacrumbItem = ZenBreacrumb.Item;
export const ToolTipDelaySecond = 1;
export const HomeBread = () => {
    return (_jsx(BreacrumbItem, { href: "/", children: _jsx(Tooltip, { title: t('G3cS6MeKFMwm'), mouseEnterDelay: ToolTipDelaySecond, children: _jsx(Icon, { style: {
                    marginTop: '2px',
                    verticalAlign: 'text-top',
                    fontSize: '16px',
                    marginRight: '4px',
                }, type: "general/HomeLine" }) }) }));
};
